import { HttpErrorResponse, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NotificationService } from "app/services";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	// Constructors
	constructor(private notificationService: NotificationService, private router: Router) {
	}

	intercept(req: HttpRequest<any>,next: HttpHandler)
		: Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>>
	{
		return <any>next.handle(req).pipe(
			catchError((error) => {
				return this.handleError(error, req, next);
			})
		);
	}

	// Private Methods
	private handle400Error(error) {
		if (error && error.status === 400 && error.error) {
			if (error.error.error === "invalid_grant") {
				// If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
				this.router.navigateByUrl("/unauthorized");
			} else if (typeof error.error === 'object') {
				let errors = Object.values(error.error) as string[];
				this.notificationService.errorMultiple(errors);
				return throwError(() => new Error("Error occurred"));
			}
		}
	}

	private handle401Error(error) {
		this.router.navigateByUrl("/unauthorized");
	}

	private handle403Error(error) {
		this.router.navigateByUrl("/forbidden");
	}

	private handle404Error(error) {
		this.router.navigateByUrl("/pageNotFound");
	}

	private handle503Error(error) {
		this.router.navigateByUrl("/maintenance");
	}

	private handleError(error, req, next): any {
		if (error instanceof HttpErrorResponse) {
			switch ((<HttpErrorResponse>error).status) {
				case 400:
					return this.handle400Error(error);
				case 401:
					return this.handle401Error(error);
				case 403:
					return this.handle403Error(error);
				case 404:
					return this.handle404Error(error);
				case 503:
					return this.handle503Error(error);
			}
		}
		return throwError(() => new Error("Error occurred"));
	}
}
